import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { TableSort } from 'components/WrappedComponents/Table/types';
import AFFilterProvider from 'hooks/AFFilterStoreContext';
import PaginationProvider, {
  DictTablePagination,
  PAGINATION_DICT_DEFAULT,
} from 'hooks/PaginationStoreContext';
import SortProvider from 'hooks/SortStoreContext';
import { useActionsRequises } from 'hooks/useActionsRequises';
import { AutoriteFourriereSortOptions } from 'pages/autorite-fourriere/Dashboard/types';
import { Statistiques } from 'pages/autorite-fourriere/Statistiques';
import { NOT_FOUND_PATH } from 'utils/enumData';

import PageComptes from './Comptes/PageComptes';
import { FilterDashboardAutoriteFourriere } from './Dashboard/DashboardHeader/Filters/types';
import { Details } from './Dossier/Details/Details';
import DashBoard from './Dashboard';

const AfRouter: React.FC = () => {
  const [pagination, setPagination] = useState<DictTablePagination>(
    PAGINATION_DICT_DEFAULT,
  );
  const [filter, setFilter] = useState<
    Partial<FilterDashboardAutoriteFourriere>
  >({});
  const [sort, setSort] = useState<
    Partial<TableSort<AutoriteFourriereSortOptions | undefined>>
  >({
    IMMATRICULATION: true,
  });

  const afActionsRequises = useActionsRequises();

  return (
    <SortProvider value={{ sort: sort, setSort: setSort }}>
      <PaginationProvider
        value={{ pagination: pagination, setPagination: setPagination }}
      >
        <AFFilterProvider
          value={{
            filter: filter,
            setFilter: setFilter,
            actionsRequises: afActionsRequises,
          }}
        >
          <Routes>
            <Route path="" element={<DashBoard />} />
            <Route path="dossier/:id" element={<Details />} />
            <Route path="statistiques" element={<Statistiques />} />
            <Route
              path="*"
              element={<Navigate replace to={NOT_FOUND_PATH} />}
            />
            <Route path="comptes" element={<PageComptes />} />
          </Routes>
        </AFFilterProvider>
      </PaginationProvider>
    </SortProvider>
  );
};

export default AfRouter;
